import React from 'react';

function SocialMediaIntroSection() {
  const handleQuoteClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const handleWorkClick = (e) => {
    e.preventDefault();
    const portfolioEl = document.getElementById('social-media-portfolio') || document.querySelector('.seo-portfolio-section');
    if (portfolioEl) {
      portfolioEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="what-is-seo-section">
      <div className="container what-is-seo-container">
        {/* Left Column: Social Media Image */}
        <div className="what-is-seo-left">
          <div className="what-is-seo-img-wrapper">
            <img
              src="/assets/images/social-media/social-img2.jpg"
              alt="Social Media Marketing Services"
              className="what-is-seo-img"
            />
          </div>
        </div>

        {/* Right Column: Title, Description, and 2 Buttons */}
        <div className="what-is-seo-right">
          <h2 className="what-is-seo-title">
            <span className="what-is-seo-red-title">Social Media Marketing</span> Services
          </h2>

          <p className="what-is-seo-desc">
            Hire the best social media marketing company to create and increase your brand’s presence on multiple social platforms. Our social media marketing agency builds true connections for you across various social media platforms. We are here to help engage with your audience and build trust and reliability among them, which converts them into your customers. Our social media marketers have expertise in using these platforms in a productive way so that we can attract more users and drive sales. Our process focuses on effective content creation and targeted advertising that adds volume to your brand’s voice on different channels.
            <br /><br />
            Want to change your social media profiles and pages to a system that drives returns?
          </p>

          <div className="what-is-seo-btn-group">
            <button className="btn-seo-primary" onClick={handleQuoteClick}>
              Get Free Quote
            </button>
            <a
              href="#social-media-portfolio"
              className="btn-seo-outline"
              onClick={handleWorkClick}
            >
              See Our Work
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMediaIntroSection;
